import { inject, Injectable } from '@angular/core';

import { Instant } from '@js-joda/core';

import { ActivityItem } from '../../../shared/interfaces';
import { SignageConfigurationModel } from '../../config/models';
import { ActivitySlideBuilder } from '../../slides/activity-slide.builder';
import { RuntimeSlideModel } from '../../slides/models';
import { BuildContextModel, FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class ActivityContentProvider implements ContentProvider<ActivityItem> {
  private readonly builder = inject(ActivitySlideBuilder);

  public readonly kind = ContentKind.Activities;
  public readonly tier = RefreshTier.Main;
  public readonly order = 30;
  public readonly presentation = PresentationSlot.Playlist;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public fetch(context: FetchContextModel): Promise<ActivityItem[]> {
    const today = context.clock.today(context.config.community.timezone);

    return context.source.loadActivities(context.config.channel, today, context.signal);
  }

  public toSlides(items: ActivityItem[], context: BuildContextModel): RuntimeSlideModel[] {
    return this.builder.build(items, context);
  }

  public isStillRelevant(slide: RuntimeSlideModel, now: Instant): boolean {
    return slide.meta.expiresAt > now.toEpochMilli();
  }
}
